import React from 'react';
import { ApolloError } from '@apollo/client';
import _ from 'lodash';

import { Typography, CircularProgress, LinearProgress } from '@occc/ui-design-system';
import { SegmentFragment } from '@occc/graphql';

import { SegmentForm } from '../components/SegmentForm';

interface ShowSegmentConfigurationProps {
  loading: boolean;
  error?: ApolloError;
  segment: SegmentFragment | null;
  disabled?: boolean;
}

const ShowSegmentConfiguration: React.FC<ShowSegmentConfigurationProps> = ({
  loading,
  error,
  segment,
  disabled,
}) => {
  if (error) {
    return <Typography color='error'>Something went wrong. Please try again.</Typography>;
  }
  if (loading && !segment) {
    return <CircularProgress />;
  }

  if (!segment) {
    return <Typography color='error'>No data. Something went wrong. Please try again.</Typography>;
  }
  const initialValues = _.pick(segment, ['name', 'description', 'shortCode']);
  return (
    <>
      {loading && <LinearProgress />}
      <SegmentForm
        readOnly={true}
        editMode={false}
        initialValues={initialValues}
        onSubmit={() => {}}
        disabled={disabled}
      />
    </>
  );
};

export default React.memo(ShowSegmentConfiguration);
